import React, { useEffect } from "react";
import PeakDay from "./PeakDay";
import {
  INBOUND_VOLUME_TAB_TITLE,
  PEAK_DAY_TAB_TITLE,
  EQUIPMENT_TAB_TITLE,
  PICK_VOLUME_TAB_TITLE,
  RESOURCE_PLAN_TAB_TITLE,
  VOLUME_BY_WEEK_TAB_TITLE,
  RECRUITMENT_PLAN_TAB_TITLE,
  RESERVE_CAPACITY_TAB_TITLE,
  PEAK_DAYS_ORDER_TAB_TITLE,
  PICK_PLAN_TAB_TITLE,
  FLOOR_CAPACITY_TAB_TITLE,
} from "./dashboardTabs";
import InboundVolume from "./InboundVolume";
import VolumeByWeek from "./VolumeByWeek";
import PickVolume from "./PickVolume";
import Equipment from "./Equipment";
import ResourcePlan from "./ResourcePlan";
import RecruitmentPlan from "./RecruitmentPlan";
import ReservceCapacity from "./ReserveCapacity";
import PeakDaysOrderView from "./PeakDaysOrder";
import PickPlanView from "./PickPlan";
import FloorCapactiy from "./FloorCapacity";

const ViewSwitcher = ({
  activeViewKey,
  api,
  store,
  updateDurationAggregator,
  ...rest
}) => {
  const viewIndex = {
    [INBOUND_VOLUME_TAB_TITLE]: InboundVolume,
    [PEAK_DAY_TAB_TITLE]: PeakDay,
    [VOLUME_BY_WEEK_TAB_TITLE]: VolumeByWeek,
    [PICK_VOLUME_TAB_TITLE]: PickVolume,
    [EQUIPMENT_TAB_TITLE]: Equipment,
    [RESOURCE_PLAN_TAB_TITLE]: ResourcePlan,
    [RECRUITMENT_PLAN_TAB_TITLE]: RecruitmentPlan,
    [RESERVE_CAPACITY_TAB_TITLE]: ReservceCapacity,
    [PEAK_DAYS_ORDER_TAB_TITLE]: PeakDaysOrderView,
    [PICK_PLAN_TAB_TITLE]: PickPlanView,
    [FLOOR_CAPACITY_TAB_TITLE]: FloorCapactiy,
  };

  const Component = viewIndex[activeViewKey];

  useEffect(() => {
    let targetWindow = "week";
    if (
      activeViewKey === PICK_PLAN_TAB_TITLE ||
      activeViewKey === RESERVE_CAPACITY_TAB_TITLE
    ) {
      targetWindow = "day";
    } else if (activeViewKey === FLOOR_CAPACITY_TAB_TITLE) {
      targetWindow = "hour";
    }
    updateDurationAggregator(targetWindow);
  }, [activeViewKey]);

  return <Component api={api} store={store} {...rest} />;
};

export default ViewSwitcher;
